import { X, Check } from "lucide-react";

const SAMEMU = [
  "Szukasz firm na własną rękę",
  "Porównujesz różne oferty",
  "Odbierasz wiele telefonów",
  "Trudno ocenić, co jest dobre",
];

const Z_NAMI = [
  "Jeden kontakt zamiast wielu",
  "Sprawdzony instalator z Twojej okolicy",
  "Pomagamy zrozumieć ofertę",
  "Spokojny proces bez chaosu",
];

export default function ComparisonSection() {
  return (
    <section
      id="porownanie"
      className="py-16 lg:py-24 bg-white"
      data-testid="comparison-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">
            Porównanie
          </p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-ink">
            Samemu vs z nami — jaka jest różnica?
          </h2>
          <p className="mt-4 text-lg text-brand-muted">
            Mniej telefonów, mniej stresu, jasna ścieżka do montażu.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {/* Samemu */}
          <div
            className="bg-white border border-brand-border rounded-3xl p-7 lg:p-8 shadow-sm relative overflow-hidden"
            data-testid="comparison-samemu"
          >
            <div className="flex items-center gap-2">
              <span className="grid place-items-center h-9 w-9 rounded-full bg-red-50 text-red-500">
                <X className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <h3 className="font-heading font-bold text-xl text-brand-ink">Samemu</h3>
            </div>
            <ul className="mt-5 space-y-3">
              {SAMEMU.map((item) => (
                <li key={item} className="flex items-start gap-3 text-brand-muted">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-red-300 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Z nami — emphasized */}
          <div
            className="bg-brand-surface border-2 border-brand-blue rounded-3xl p-7 lg:p-8 shadow-lg relative overflow-hidden"
            data-testid="comparison-znami"
          >
            <div
              aria-hidden="true"
              className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-brand-yellow/30 blur-3xl"
            />
            <div className="relative">
              <div className="flex items-center gap-2">
                <span className="grid place-items-center h-9 w-9 rounded-full bg-emerald-100 text-emerald-700">
                  <Check className="h-5 w-5" strokeWidth={2.4} />
                </span>
                <h3 className="font-heading font-bold text-xl text-brand-ink">Z nami</h3>
                <span className="ml-auto text-xs font-bold uppercase tracking-wider bg-brand-yellow text-brand-yellowFg px-2.5 py-1 rounded-full">
                  Polecane
                </span>
              </div>
              <ul className="mt-5 space-y-3">
                {Z_NAMI.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-brand-ink">
                    <Check className="h-5 w-5 text-emerald-600 flex-shrink-0 mt-0.5" strokeWidth={2.2} />
                    <span className="font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
